// extracted by mini-css-extract-plugin
export default {"section":"ah9ox6bmcosU2LTq6Cu8","pulse":"EnVpHUaTrjmv881MmpLp"};